import React, { useContext, useEffect, useState } from "react";
import SectionCard from "../components/SectionCard";
import { Label, Input } from "../components/FormControls";
import { Printer } from "lucide-react";
import { toast } from "react-toastify";
import { GlobalContext } from "../../../../Context/GlobalContext";

import useOrderSettings from "../../../Services/OrderServices/OrderSettingsServices/useOrderSettings";

export default function PrintingSection({ userID }) {
  const {getReceiptData, updatePrintSettings}=useOrderSettings();

  const { api } = useContext(GlobalContext);
  const [details, setDetails] = useState(null);
  const [form, setForm] = useState({
    normalFontSize: "", largeFontSize: "", pageWidth: "",
    anlookActive: false, autoPrint: false,
  });

const load = async () => {
  if (!userID) return;

  try {
    const result =
      await getReceiptData(userID);

    if (result.success) {
      const row = result.data?.[0] || null;

      let printSettings = [];

      try {
        if (row?.printSettings) {
          printSettings =
            typeof row.printSettings === "string"
              ? JSON.parse(row.printSettings)
              : row.printSettings;
        }
      } catch {}

      setDetails({
        ...row,
        printSettings,
      });
    } else {
      setDetails(null);
      // optional:
      // toast.error(result.message);
    }
  } catch {
    setDetails(null);
  }
};


const save = async () => {
  const {
    normalFontSize,
    largeFontSize,
    pageWidth,
    anlookActive,
    autoPrint,
  } = form;

  if (
    !normalFontSize ||
    !largeFontSize ||
    !pageWidth
  )
    return toast.error("Fill all size fields");

  try {
    const result =
      await updatePrintSettings({
        userid: userID,
        normalFontSize,
        largeFontSize,
        pageWidth,
        anlookActive,
        autoPrint,
      });

    if (result.success) {
      toast.success(result.message);

      setForm({
        normalFontSize: "",
        largeFontSize: "",
        pageWidth: "",
        anlookActive: false,
        autoPrint: false,
      });

      load();
    } else {
      toast.error(result.message);
    }
  } catch {
    toast.error("Failed");
  }
};


  useEffect(() => { load(); }, [userID]); // eslint-disable-line

  return (
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
      <SectionCard icon={Printer} title="Print Settings (Current)">
        {details ? (
          <div className="space-y-2 text-sm">
            <div className="grid grid-cols-2 gap-3">
              {(details?.printSettings || []).slice(0,3).map((p,i)=>(
                <div key={i}><div className="font-medium text-gray-900">{p.key}</div><div className="text-gray-600">{p.value}</div></div>
              ))}
            </div>
            <div className="mt-3 grid grid-cols-2 gap-3">
              <div>
                <div className="font-medium text-gray-900">Anlook Active</div>
                <div className="text-gray-600">
                  {(details?.printSettings || []).find((x)=>x.key==="anlookActive")?.value === "1" ? "Enabled":"Disabled"}
                </div>
              </div>
              <div>
                <div className="font-medium text-gray-900">Auto Print</div>
                <div className="text-gray-600">
                  {(details?.printSettings || []).find((x)=>x.key==="autoPrint")?.value === "1" ? "Enabled":"Disabled"}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="text-sm text-gray-500">No data</div>
        )}
      </SectionCard>

      <SectionCard icon={Printer} title="Update Print Settings">
        <div className="space-y-3">
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
            <div><Label>Normal Font Size (px)</Label><Input value={form.normalFontSize} onChange={(e)=>setForm(s=>({...s,normalFontSize:e.target.value}))} /></div>
            <div><Label>Large Font Size (px)</Label><Input value={form.largeFontSize} onChange={(e)=>setForm(s=>({...s,largeFontSize:e.target.value}))} /></div>
            <div><Label>Page Width (mm)</Label><Input value={form.pageWidth} onChange={(e)=>setForm(s=>({...s,pageWidth:e.target.value}))} /></div>
          </div>
          <div className="flex items-center gap-3">
            <label className="inline-flex items-center gap-2 text-sm text-gray-700">
              <input type="checkbox" className="h-4 w-4 accent-emerald-600"
                     checked={form.anlookActive} onChange={(e)=>setForm(s=>({...s,anlookActive:e.target.checked}))} />
              Use Anlook Printing Software
            </label>
            <label className="inline-flex items-center gap-2 text-sm text-gray-700">
              <input type="checkbox" className="h-4 w-4 accent-emerald-600"
                     checked={form.autoPrint} onChange={(e)=>setForm(s=>({...s,autoPrint:e.target.checked}))} />
              Auto Print
            </label>
          </div>
          <button onClick={save} className="rounded-lg bg-emerald-600 px-4 py-2 text-sm font-semibold text-white hover:bg-emerald-700">
            Save
          </button>
        </div>
      </SectionCard>
    </div>
  );
}
